// eslint-disable-next-line @typescript-eslint/no-explicit-any
const config = (window as any).__ENV__ ?? {};

export const VITE_PROD = config.PROD ?? import.meta.env.PROD;
export const VITE_MODE = config.MODE ?? import.meta.env.MODE;
export const VITE_ENVIRONMENT =
  config.VITE_ENVIRONMENT ?? import.meta.env.VITE_ENVIRONMENT;
export const VITE_RELEASE_TIME =
  config.VITE_RELEASE_TIME ?? import.meta.env.VITE_RELEASE_TIME;
export const VITE_BYPASS_TEST_MAILS_ENABLED =
  config.VITE_BYPASS_TEST_MAILS_ENABLED ??
  import.meta.env.VITE_BYPASS_TEST_MAILS_ENABLED;
export const VITE_KEY_PLACE_AUTOCOMPLETE =
  config.VITE_KEY_PLACE_AUTOCOMPLETE ??
  import.meta.env.VITE_KEY_PLACE_AUTOCOMPLETE;
export const VITE_BASE_API_URL =
  config.VITE_BASE_API_URL ?? import.meta.env.VITE_BASE_API_URL;
export const VITE_GTM_ID = config.VITE_GTM_ID ?? import.meta.env.VITE_GTM_ID;
export const VITE_BUGFENDER_APP_KEY =
  config.VITE_BUGFENDER_APP_KEY ?? import.meta.env.VITE_BUGFENDER_APP_KEY;
export const VITE_APP_CAYMAN_BASE_URL =
  config.VITE_APP_CAYMAN_BASE_URL ?? import.meta.env.VITE_APP_CAYMAN_BASE_URL;
export const VITE_APP_BASE_URL =
  config.VITE_APP_BASE_URL ?? import.meta.env.VITE_APP_BASE_URL;
export const VITE_SUPER_APP_IOS_STORE_URL =
  config.VITE_SUPER_APP_IOS_STORE_URL ??
  import.meta.env.VITE_SUPER_APP_IOS_STORE_URL;
export const VITE_SUPER_APP_ANDROID_STORE_URL =
  config.VITE_SUPER_APP_ANDROID_STORE_URL ??
  import.meta.env.VITE_SUPER_APP_ANDROID_STORE_URL;
export const VITE_EXC_TENANTS =
  config.VITE_EXC_TENANTS ?? import.meta.env.VITE_EXC_TENANTS;
export const BASE_URL = config.BASE_URL ?? import.meta.env.BASE_URL;
export const VITE_BUILD_ID =
  config.VITE_BUILD_ID ?? import.meta.env.VITE_BUILD_ID;
export const VITE_VERSION = config.VITE_VERSION ?? import.meta.env.VITE_VERSION;
export const VITE_RIGHT_START_ENABLED =
  config.VITE_RIGHT_START_ENABLED ?? import.meta.env.VITE_RIGHT_START_ENABLED;

export const IS_DEVELOPMENT = VITE_ENVIRONMENT === 'DEVELOPMENT';
export const IS_PRODUCTION = VITE_ENVIRONMENT === 'PRODUCTION';
export const IS_STAGING = VITE_ENVIRONMENT === 'STAGING';
export const IS_RIGHT_START_ENABLED = VITE_RIGHT_START_ENABLED === 'true';

/**
 * Returns the asset path with the base URL prefix.
 */
export const getAssetPath = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  const normalizedBase = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;
  return `${normalizedBase}${cleanPath}`;
};
